/*
 * @Description:
 * @Date: 2018-12-21 17:03:28
 */

/*
  {loading} 页面list渲染时的loadingUI控制
  {tableData} list页面数据
  Function callback 混合页面传入的回掉方法
*/
import { mapState, mapMutations } from 'vuex';

export const pageInation = {
  data() {
    return {
      whiteListRoute: [
        '/operation/newsPushNewsList',
        '/train/class',
        '/operation/keyword',
        '/operation/banner',
        '/operation/codeRed',
        '/operation/codeRed',
        '/operation/floating',
        '/content/channelVideoList',
        '/content/channelInforCaseList',
        '/content/materialList',
        '/content/faceList',
        '/onlinePromotion/extension/list',
        '/onlinePromotion/content/list',
        '/onlinePromotion/zone/list',
        '/train/class/child/course-list',
        '/train/class/child/students-list'
      ], // 因为 列表 会有 子集列表 导致子集分页存储值不服会重复请求2此 如父列表第2页 子列表只有1页 因为通用一套分页 导致父进子列表请求两次
      loading: false, //  table加载loading
      tableData: [], // 列表数据LIST
      tableResp: {}, // 列表数据 DATA
      totalPages: 0, // 总页数
      totalElements: 0, //总条数
      paginationData: {
        //提交分页数据
        pageNo: 1, // 当前页
        pageSize: 15 // 每页显示条
      },
      callback: '' // 回调
    };
  },
  computed: {
    ...mapState({
      num: state => state.pageNum.num // 修改后 转跳列表时保存上次进入时的页码
    })
  },
  methods: {
    ...mapMutations(['SET_PAGENUM']),
    // 平滑回到顶部
    toTop() {
      let gotoTop = () => {
        let currentPosition =
          document.documentElement.scrollTop || document.body.scrollTop;
        currentPosition -= 10;
        if (currentPosition > 0) {
          window.scrollTo(0, currentPosition);
        } else {
          window.scrollTo(0, 0);
          clearInterval(timer);
          timer = null;
        }
      };
      let timer = setInterval(gotoTop, 1);
    },
    // 保存成功后的回掉
    saveSuccess(val) {
      this.getPageList(this.num ? this.num : 1);
    },
    handleSizeChange(val) {},
    // 换页
    handleCurrentChange(val) {
      this.toTop();

      this.paginationData.pageNo = val;
    },
    // 初始化 分页数据
    /**
       * [initPage description]
       * @param  {[pageValue]} 返回数据
       * @param  {[pageNo]} 当前页码

       */
    initPage(resp, pageNo) {
      // this.currentPage = pageValue.currentPage
      this.totalElements = resp.total;
      // this.totalPages = Math.ceil(this.totalElements / this.paginationData.pageSize)
      // this.paginationData.pageNo = pageNo
      // pageNo?this.$set(this.paginationData,'pageNo',pageNo):''
      this.tableResp = resp;
      this.tableData = resp.list || resp;
      if (this.editFlag == 2 && this.tempInfoList.length > 0) {
        this.tempInfoList.forEach((item, index) => {
          this.tableData.forEach((item2, index2) => {
            if (item2.id == item.id) {
              this.tableData.splice(index2, 1, item);
            }
          });
        });
      }
      this.loading = false;
      this.$nextTick(() => {
        this.fkElementPaginationInitCurrentNo(pageNo);
        if (this.methodCallback && typeof this.methodCallback == 'function') {
          this.methodCallback();
        }
      });
    },
    // cao currentPage 赋值不触发element组件  暂时直接调用内部方法
    fkElementPaginationInitCurrentNo(pageNo) {
      this.$children.forEach(item => {
        if (item.$options.name == 'ElPagination') {
          item.handleCurrentChange(pageNo);
        }
      });
    },
    // 搜索 传递搜索参数
    searchEvent() {
      // this.paginationData.pageNo = 1
      this.getPageList(1);
    },
    // route 改变后 初始化数据
    initWatchRouteChange() {
      this.getPageList(1);
    },
    // 对应分页加载处理
    /**
       * [getPageList description]
       * @param  {[pageNo]} 当前页码 默认1

       */
    getPageList(pageNo = 1) {
      this.loading = true;
      // let pn = this.num || pageNo
      // pn ?this.$set(this.paginationData,'pageNo',pn):''
      // this.$set(this.paginationData,'pageNo',pageNo)
      // getList 为page页面传进来的方法
      this.paginationData.pageNo = pageNo;

      this.getList({
        ...this.paginationData,
        ...this.searchQuery
      }).then(res => {
        let resp = res.data.data;
        this.initPage(resp, pageNo);
        // setTimeout(_ => {
        //   this.$set(this.paginationData,'pageNo', 3)
        // },2000)
      });
    }
  },

  watch: {
    'paginationData.pageNo'(n, o) {
      if (!this.whiteListRoute.includes(this.$route.path)) {
        // 如果是子列表 默认进入就是第一页 并且不改变 全局分页的当前页数
        this.SET_PAGENUM(n);
      }
      if (!this.loading) {
        this.getPageList(n);
      }
    }
  },
  beforeMount() {
    // 初始化数据与分页

    if (this.num > 1) {
      this.paginationData.pageNo = !this.whiteListRoute.includes(
        this.$route.path
      )
        ? this.num
        : 1;
    } else {
      this.getPageList(1);
    }
  }
};
